var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDz(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 512,
    width: 512,
    id: "flag-icon-css-dz",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M256 0h256v512H256z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#006233",
    d: "M0 0h256v512H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M366.933 192a128 128 0 1 0 0 128 102.4 102.4 0 1 1 0-128m4.267 64L256 218.453l71.68 98.134V195.413L256 293.547z",
    fill: "#d21034"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDz);
export default __webpack_public_path__ + "static/media/dz.f2045402a84a8cd6f44774685ba28b5c.svg";
export { ForwardRef as ReactComponent };